<template>
  <div class="customer-list">
    <div class="search-box">
      <van-search
        v-model="filterData.searchKey"
        placeholder="请输入关键词进行搜索"
        show-action
      />
    </div>
    <van-dropdown-menu active-color="#FF6B31" class="dropdown">
      <van-dropdown-item
        v-model="filterData.status"
        :title="state"
        :options="stateList"
        @change="changeState"
      >
      </van-dropdown-item>
      <van-dropdown-item
        v-model="filterData.customerTag"
        :title="label"
        :options="actions"
        @change="changeTitle"
      />
      <van-dropdown-item
        v-model="filterData.sourceType"
        :title="sourceText"
        :options="source"
        @change="changeSource"
      />
      <van-dropdown-item
        v-model="filterData.endDate"
        :title="timer"
        ref="timerRef"
        @open="timeOpen"
      />
    </van-dropdown-menu>
    <refresh-list
      @onLoad="onLoad"
      :list="list"
      @onRefresh="init"
      ref="refreshList"
    >
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          :name="index"
          :is-link="false"
          v-for="(item, index) in list"
          :key="index"
        >
          <template #title>
            <div class="title">
              <div class="title-left">
                <div class="name">{{ item.customerName }}</div>
                <div class="number">{{ item.customerPhone }}</div>
              </div>
              <a :href="'tel:' + item.customerPhone">
                <img class="right-img" src="@/assets/icons/icon_phone.png" />
              </a>
            </div>
          </template>
          <div class="content">
            <div class="list">
              <span class="list-left">活动名称</span>
              <span class="list-right">{{ item.activityTitle }}</span>
            </div>
            <div class="list">
              <span class="list-left">活动ID</span>
              <span class="list-right">{{ item.activityId }}</span>
            </div>
            <div class="list">
              <span class="list-left">来源</span>
              <span class="list-right">{{ item.sourceType | sourceType }} {{ item.orderNo.startsWith('387L') ? '(银联)' : '(微信)' }}</span>
            </div>
            <div class="list">
              <span class="list-left">分享门店</span>
              <span class="list-right">{{ item.storeName }}</span>
            </div>
            <div class="list">
              <span class="list-left">分享人</span>
              <span class="list-right">{{ item.h5UserName }}</span>
            </div>
            <div class="list">
              <span class="list-left">核销人</span>
              <span class="list-right">{{ item.verificationUserName }}</span>
            </div>
            <div class="list">
              <span class="list-left">创建时间</span>
              <span class="list-right">{{ item.createdTime }}</span>
            </div>
            <div class="list">
              <span class="list-left">状态</span>
              <span class="list-right"> {{ item.status | status }}</span>
            </div>
            <div class="list">
              <span class="list-left">标签</span>
              <span class="list-right">
                <van-popover
                  v-model="item.showPopover"
                  trigger="click"
                  theme="dark"
                  :actions="actions.slice(-4)"
                  @select="(action) => changeTag(action, item)"
                  placement="bottom-end"
                >
                  <template #reference>
                    {{ item.customerTag | formatSignupTag }}
                  </template>
                </van-popover>
              </span>
            </div>
            <div class="list">
              <span class="list-left">实付金额(元)</span>
              <span class="list-right">{{ item.amount }}</span>
            </div>
            <div
              class="list"
              v-for="(fieldItem, fieldIndex) in item.customFieldStr"
              :key="fieldIndex"
            >
              <span class="list-left">{{ fieldItem.fieldKey }}</span>
              <span class="list-right">{{ fieldItem.fieldValue }}</span>
            </div>
            <template v-if="item.status == 3 || item.status == 4 || item.status == 5 || item.status == 6">
              <div class="list" v-if="item.status == 5">
                <span class="list-left">剩余处理时间</span>
                <span class="list-right">{{ item.surplusTime }}</span>
              </div>
              <template v-if="item.status != 6">
                <div class="list">
                  <span class="list-left">申请退款时间</span>
                  <span class="list-right">{{ item.refundDate }}</span>
                </div>
                <div class="list">
                  <span class="list-left">申请退款理由</span>
                  <span class="list-right">{{ item.reasonType }}</span>
                </div>
                <div class="list">
                  <span class="list-left">补充退款理由</span>
                  <span class="list-right">{{ item.additionalReason }}</span>
                </div>
                <div class="list special">
                  <span class="list-left">补充退款凭证</span>
                  <div class="list-right" v-if="item.supplementaryPic">
                    <img
                      class="img-box"
                      :src="imgItem.url"
                      v-for="(imgItem, imgIndex) in JSON.parse(item.supplementaryPic)"
                      :key="imgIndex"
                      @click="imgPreview(item.supplementaryPic, imgIndex)"
                    />
                  </div>
                </div>
              </template>
              <template v-if="item.status == 6">
                <div class="list">
                  <span class="list-left">下线退款时间</span>
                  <span class="list-right">{{ item.offlineRefundTime }}</span>
                </div>
                <div class="list special">
                  <span class="list-left">线下退款凭证</span>
                  <div class="list-right" v-if="item.offlineRefundProofPic">
                    <img
                      class="img-box"
                      :src="imgItem.url"
                      v-for="(imgItem, imgIndex) in JSON.parse(item.offlineRefundProofPic)"
                      :key="imgIndex"
                      @click="imgPreview(item.offlineRefundProofPic, imgIndex)"
                    />
                  </div>
                </div>
              </template>
              <!-- 待退款 -->
              <template v-if="item.status == 5">
                <div class="btn-box" v-if="item.refundStatus != 4">
                  <!-- 同意退款：只有“经销商”和“店长”支持查看和操作 -->
                  <div
                    class="btn-item secondary"
                    v-if="item.refundStatus == 0 && (isDistributor || isShopowner)"
                    @click="refund(item)"
                  >
                    拒绝退款
                  </div>
                  <!-- 拒绝退款理由：所有角色支持查看 -->
                  <div
                    class="btn-item secondary"
                    v-if="item.refundStatus == 2"
                    @click="refund(item)"
                  >
                    拒绝退款理由
                  </div>
                  <!-- 同意退款：只有“经销商”和“店长”支持查看和操作 -->
                  <div
                    class="btn-item"
                    v-if="isDistributor || isShopowner"
                    @click="consent(item)"
                  >
                    {{ item.refundStatus == 0 ? "同意退款" : "平台审核中" }}
                  </div>
                </div>
                <template v-if="item.refundStatus == 4">
                  <div class="list">
                    <span class="list-left">同意退款时间</span>
                    <span class="list-right">{{ item.checkTime }}</span>
                  </div>
                  <div class="list">
                    <span class="list-left">同意操作人</span>
                    <span class="list-right">{{ item.checkUserName }}</span>
                  </div>
                </template>
              </template>
            </template>
          </div>
        </van-collapse-item>
      </van-collapse>
    </refresh-list>
    <van-calendar
      :min-date="minDate"
      :max-date="maxDate"
      v-model="isTime"
      type="range"
      color="#FF6B31"
      :default-date="currentDate"
      @confirm="changeEndDate"
      allow-same-day
      ref="calendarRef"
    >
      <div slot="title" class="title-time">
        <span @click="reset">重置</span>
      </div>
    </van-calendar>
    <refund-pop
      :showRefundPop.sync="showRefundPop"
      @rejectRefund="init"
      :refundParames="refundParames"
    />
    <offline-refund-pop
      :showofflineRefundPop.sync="showofflineRefundPop"
      :orderNo="orderNo"
    />
  </div>
</template>

<script>
import dayjs from "@/utils/dayjs";
import refreshList from "@/components/refresh-list/refresh-list";
import refundPop from "./components/refund-pop";
import offlineRefundPop from './components/offline-refund-pop';
import { ImagePreview } from "vant";
import { mapGetters } from "vuex";
import { decode } from "@/utils/encryption";
import _ from 'lodash'
const DEFAULTSTARTDATE = dayjs().subtract(31, "day").format("YYYY-MM-DD 00:00:00");
const DEFAULTENDDATE = dayjs().format("YYYY-MM-DD 23:59:59");
export default {
  components: {
    refreshList,
    refundPop,
    offlineRefundPop,
  },
  computed: {
    ...mapGetters([
      "isTeacher",
      "isDistributor",
      "isShopowner",
      "isGuide",
      "userInfo",
    ]),
  },
  data() {
    return {
      state: this.$route.query.state ? "待退款(报名)" : "状态",
      label: "标签",
      sourceText: "报名",
      timer: `${DEFAULTSTARTDATE}-${DEFAULTENDDATE}`,

      filterData: {
        activityId: this.$route.query.activityId || "",
        searchKey: "",
        status: this.$route.query.state || null,
        customerTag: null,
        sourceType: "signUp",
        startDate: DEFAULTSTARTDATE,
        endDate: DEFAULTENDDATE,
      },
      activeName: "1",
      stateList: [
        { text: "全部", value: null },
        { text: "已报名(报名)", value: 1 },
        { text: "已核销(报名)", value: 2 },
        { text: "已退款(报名)", value: 3 },
        { text: "退款中(报名)", value: 4 },
        { text: "待退款(报名)", value: 5 },
        { text: "已退款-下线(报名)", value: 6 },
        { text: "待兑奖(抽奖)", value: 11 },
        { text: "已兑奖(抽奖)", value: 12 },
        { text: "发放异常(抽奖)", value: 13 },
        { text: "未兑奖已过期(抽奖)", value: 14 },
        { text: "已支付待核销(秒杀)", value: 21 },
        { text: "已核销(秒杀)", value: 22 },

        { text: "已支付待核销(拼团)", value: 31 },
        { text: "已核销(拼团)", value: 32 },
        { text: "客户已退款(拼团)", value: 33 },
        { text: "超时支付已退款(拼团)", value: 34 },
        { text: "退款中(拼团)", value: 35 },
        { text: "超时支付待退款(拼团)", value: 36 },
        { text: "已支付待成团(拼团)", value: 37 },

        { text: "待核销(优惠券)", value: 41 },
        { text: "已核销(优惠券)", value: 42 },
        { text: "已过期(优惠券)", value: 43 },
      ],
      actions: [
        { text: "全部", value: null },
        { text: "已进店", value: 1 },
        { text: "未进店", value: 2 },
        { text: "已成交", value: 3 },
        { text: "已流失", value: 4 },
      ],
      source: [
        // {text: '全部',value: null},
        { text: "报名", value: "signUp" },
        { text: "抽奖", value: "lottery" },
        { text: "秒杀", value: "seckill" },
        { text: "拼团", value: "groupBuying" },
        { text: "优惠券", value: "coupon" },
      ],
      list: [],
      pageNum: 1,
      pageSize: 10,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: [new Date(DEFAULTSTARTDATE), new Date(DEFAULTENDDATE)],
      isTime: false,
      showRefundPop: false,
      showofflineRefundPop: false,
      refundParames: {},
      isFirsEnter: true,
      debounce: null,
      orderNo: ''
    };
  },
  watch: {
    "filterData.searchKey": {
      handler(value) {
        this.isFirsEnter = true;
        this.debounce();
      },
    },
  },
  mounted() {
    if (this.$route.query.state) {
      this.resetDateTime()
    }
    this.init();
    // 监听退款成功刷新页面
    this.bus.$on("rejectRefund", () => {
      this.init();
    });
    this.debounce = _.debounce(this.init, 500)
  },
  methods: {
    onLoad() {
      this.getList();
    },
    init() {
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    changeState() {
      this.state = this.filterData.status == null ? "状态" : "";
      this.isFirsEnter = true;
      const {status,startDate  } = this.filterData
      if (status == 4 || status == 5) {
        this.resetDateTime()
      } else {
        this.initDateTime()
      }
      this.init();
    },
    changeTitle() {
      this.label = this.filterData.customerTag == null ? "标签" : "";
      this.isFirsEnter = true;
      this.initDateTime()
      this.init();
    },
    changeSource() {
      this.sourceText = this.filterData.sourceType == null ? "来源" : "";
      this.isFirsEnter = true;
      this.initDateTime()
      this.init();
    },
    timeOpen() {
      this.$refs.calendarRef.scrollToDate(new Date());
      this.isFirsEnter = true;
      this.isTime = true;
    },
    changeEndDate(e) {
      this.filterData.startDate =
        dayjs(e[0]).format("YYYY-MM-DD") + " 00:00:00";
      this.filterData.endDate = dayjs(e[1]).format("YYYY-MM-DD") + " 23:59:59";
      this.timer = this.filterData.startDate + "-" + this.filterData.endDate;
      this.isTime = false;
      // this.$refs.timerRef.toggle();
      this.init();
    },
    reset() {
      this.$refs.calendarRef.reset();
      this.filterData.startDate = DEFAULTSTARTDATE;
      this.filterData.endDate = DEFAULTENDDATE;
      this.timer = DEFAULTSTARTDATE + '-' + DEFAULTENDDATE
      this.init();
    },
    getList() {
      let data = {
        filterData: this.filterData,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      let toastLoding = null;
      if (this.isFirsEnter) {
        this.isFirsEnter = false;
        toastLoding = this.$toast.loading({
          duration: 0,
          message: "加载中...",
        });
      }
      this.$api.customerList.getDataList(data)
        .then((res) => {
          if (res.code == 200) {
            const list = res.data.list.map((item) => ({
              ...item,
              customFieldStr: JSON.parse(item.customFieldStr),
              showPopover: false,
              customerPhone: item.customerPhone
                ? item.customerPhone
                : decode(item.userPhoneRsa),
            }));
            this.list.push(...list);
            this.pageNum = res.data.pageNum + 1;
            this.$refs["refreshList"].complete(res.data);
          } else {
            this.$refs["refreshList"].onFinish();
          }
        })
        .catch((err) => {
          this.$refs["refreshList"].onFinish();
        })
        .finally(() => {
          if (toastLoding) {
            toastLoding.clear();
          }
        });
    },
    changeTag(action, item) {
      this.$api.h5
        .updateCustomerTag(item.joinLogId, action.value, item.sourceType)
        .then(() => {
          item.customerTag = action.value;
        });
    },
    refund(item) {
      this.$router.push({
        path: "/reject-refund",
        query: item,
      });
    },
    imgPreview(imgStr, index) {
      ImagePreview({
        images: JSON.parse(imgStr)?.map((item) => item.url),
        startPosition: index,
      });
    },
    consent(item) {
      if (item.refundStatus == 0) {
        this.$dialog
          .confirm({
            title: "提示",
            message: "确认同意退款吗？",
          })
          .then(() => {
            this.$api.customerList.agreeRefund(item.orderNo).then((res) => {
              if (res.success && res.data != '经销商钱包余额不足') {
                this.$toast("退款成功");
                this.init();
              } else {
                this.orderNo = item.orderNo
                this.showofflineRefundPop = true
              }
            });
          });
      }
    },
    initDateTime() {
      const {startDate  } = this.filterData
      if (!startDate) {
        this.filterData.startDate = DEFAULTSTARTDATE
        this.filterData.endDate = DEFAULTENDDATE
        this.timer = `${DEFAULTSTARTDATE}-${DEFAULTENDDATE}`
        this.currentDate = [new Date(DEFAULTSTARTDATE), new Date(DEFAULTENDDATE)]
      }
    },
    resetDateTime() {
      this.filterData.startDate = ''
      this.filterData.endDate = ''
      this.timer = '全部'
      this.currentDate = []
    },
  },
  filters: {
    status(state) {
      let map = {
        1: "已报名(报名)",
        2: "已核销(报名)",
        3: "已退款(报名)",
        4: "退款中(报名)",
        5: "待退款(报名)",
        6: "已退款-下线(报名)",
        11: "待兑奖(抽奖)",
        12: "已兑奖(抽奖)",
        13: "发放异常(抽奖)",
        14: "未兑奖已过期(抽奖)",
        21: "已支付待核销(秒杀)",
        22: "已核销(秒杀)",
        31: "已支付待核销(拼团)",
        32: "已核销(拼团)",
        33: "客户已退款(拼团)",
        34: "超时支付已退款(拼团)",
        35: "退款中(拼团)",
        36: "超时支付待退款(拼团)",
        37: "已支付待成团(拼团)",
        37: "已支付待成团(拼团)",
        41: "待核销(优惠券)",
        42: "已核销(优惠券)",
        43: "已过期(优惠券)",
      };
      return map[state];
    },
    sourceType(state) {
      let map = {
        signUp: "报名",
        lottery: "抽奖",
        seckill: "秒杀",
        groupBuying: "拼团",
        coupon: '优惠券'
      };
      return map[state];
    },
    formatSignupTag(val) {
      if (val == 1) {
        return "已进店";
      } else if (val == 2) {
        return "未进店";
      } else if (val == 3) {
        return "已成交";
      } else if (val == 4) {
        return "已流失";
      } else {
        return "请选择";
      }
    },
    reasonType(val) {
      let map = {
        1: "我不想要了",
        2: "门店联系我的退款",
        3: "活动内容与实际宣传不符",
        4: "其他",
      };
      return map[val];
    },
    refundStatusStr(state) {
      let map = {
        0: "拒绝退款",
        2: "拒绝退款理由",
      };
      return map[state];
    },
  },
};
</script>
<style lang="stylus" scoped>
.customer-list {
  .search-box {
    background: #fff;
  }
  .van-pull-refresh {
    min-height: 100vh;
    .title {
      display: flex;
      justify-content: space-between;
      .title-left {
        color: #333333;
        font-size: 16px;
        .number {
          color: #999999;
          font-size: 13px
        }
      }
      .right-img {
        width 32px
        height 32px
      }
    }
    .content {
      .list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 10px 0;
        color: #999999;
        font-size: 14px;
        .list-right {
          position relative
          display: flex;
          justify-content: flex-end;
          align-items: center;
          width: 250px;
          flex-wrap: wrap;
          color: #333333;
          .img-box {
            width: 60px;
            height: 60px;
            border-radius: 6px;
            margin-left: 6px;
            margin-bottom: 10px;
            background: #ccc;
          }
        }
      }
      .special {
        align-items: flex-start;
      }
      .btn-box {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .btn-item {
          width: 110px;
          height: 30px;
          color: #fff;
          font-size: 14px;
          text-align: center;
          line-height: 32px;
          background: #FF6B31;
          border-radius: 4px;
          border: 1px solid transparent;
        }
        .secondary {
          color: #FF6B31;
          border: 1px solid #FF6B31;
          background: #fff;
        }
      }
    }
  }
  .dropdown {
   /deep/ .van-dropdown-menu__item {
      max-width: 90px;
   }
  }
  .title-time {
    width: 20%;
  }
}
</style>
